import React, { useState } from "react";

const CoreComponent31 = ({ custom }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div>
      <div className="row d-flex justify-content-center">
        {custom.map((val, i) => (
          <div
            className="col-lg-4 col-md-6 mb-4"
            key={i}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div
              className="p-3 mb-4 bg-white border text-center h-100 rounded-4"
              style={{
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                transform:
                  hoveredIndex === i ? "scale(1.05)" : "scale(1)",
                boxShadow:
                  hoveredIndex === i
                    ? "0 10px 20px rgba(0,0,0,0.2)"
                    : "none",
              }}
            >
              <img
                src={val.icon}
                alt=""
                style={{
                  height: 50,
                  width: 50,
                  transition: "transform 0.3s ease",
                  transform:
                    hoveredIndex === i
                      ? "scale(1.3) rotateX(10deg) rotateY(10deg)"
                      : "scale(1)",
                }}
              />
              <h3
                className="my-3 h3-heading pt-1 fs-5 semi-bold"
                style={{
                  color: hoveredIndex === i ? "black" : "#000",
                  transition: "color 0.3s ease",
                }}
              >
                {val.title}
              </h3>
              <p
                className="fs-6 h3-para lh-base"
                style={{
                  color: hoveredIndex === i ? "black" : "black",
                  transition: "color 0.3s ease",
                }}
              >
                {val.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreComponent31;
